const designReducer = ( state = {
  ...window.parent.ShopifyBotData.design,
  name: window.parent.ShopifyBotData.name
}) => {
  return state;
};

export { designReducer };
